package com.zaurh.mapquizwebsite.presentation.screen.daily_reward

import com.zaurh.mapquizwebsite.domain.model.DailyRewardAction
import com.zaurh.mapquizwebsite.domain.model.DailyRewardDO
import com.zaurh.mapquizwebsite.domain.model.UserDataDO
import com.zaurh.mapquizwebsite.presentation.screen.home.MainAction
import com.zaurh.mapquizwebsite.presentation.screen.home.MainSideEffect
import com.zaurh.mapquizwebsite.utils.EMPTY

data class DailyRewardsUIState(
    val isLoading: Boolean = false,
    val action: DailyRewardAction = DailyRewardAction.TIMER,
    val nextClaimAt: Long? = null,
    val dailyRewards: List<DailyRewardDO> = emptyList()
)

sealed interface DailyRewardsAction {
    data object OnInit : DailyRewardsAction
    data object OnClaimReward : DailyRewardsAction
}

sealed interface DailyRewardsSideEffect {

}